import React, { useEffect, useState } from 'react';
import { posVentas, posCajas, posVentaDetalle, posDevolucion } from '../services/api';

const fmt = (n) => '$' + Number(n || 0).toLocaleString('es-CO');
const fdt = (d) => d ? new Date(d).toLocaleString('es-CO') : '—';
const hoy = () => new Date(Date.now() - 5 * 3600 * 1000).toISOString().slice(0, 10); // Colombia
const TIPO_BADGE = {
  fe: { l: 'FE', bg: '#0e2a1b', c: '#6ee7b7' },
  de: { l: 'DEE', bg: '#0e2a1b', c: '#6ee7b7' },
  recibo: { l: 'Recibo', bg: '#1e293b', c: '#94a3b8' },
  devolucion: { l: 'Devolución', bg: '#3f1d1d', c: '#fca5a5' },
};

export default function ReportePos() {
  const [desde, setDesde] = useState(hoy());
  const [hasta, setHasta] = useState(hoy());
  const [rep, setRep] = useState(null);
  const [cajas, setCajas] = useState([]);
  const [tab, setTab] = useState('ventas');
  const [devolver, setDevolver] = useState(null); // venta a devolver
  const [flash, setFlash] = useState(null);
  const aviso = (ok, t) => { setFlash({ ok, t }); setTimeout(() => setFlash(null), 4000); };

  const cargar = () => posVentas({ desde, hasta }).then(r => setRep(r.data)).catch(() => setRep({ ventas: [], totales: {} }));
  useEffect(() => { cargar(); /* eslint-disable-next-line */ }, []);
  useEffect(() => { posCajas().then(r => setCajas(r.data)).catch(() => setCajas([])); }, []);

  const t = rep?.totales || {};
  return (
    <div>
      <div style={s.pageHeader}>
        <div><h1 style={s.h1}>Ventas POS</h1><p style={s.sub}>Reporte de ventas y cierres de caja del punto de venta</p></div>
        {tab === 'ventas' && (
          <div style={s.filtros}>
            <label style={s.lbl}>Desde</label><input type="date" style={s.in} value={desde} onChange={e => setDesde(e.target.value)} />
            <label style={s.lbl}>Hasta</label><input type="date" style={s.in} value={hasta} onChange={e => setHasta(e.target.value)} />
            <button style={s.btn} onClick={cargar}>Ver</button>
          </div>
        )}
      </div>
      {flash && <div style={{ ...s.flash, background: flash.ok ? '#064e3b' : '#3f1d1d', color: flash.ok ? '#6ee7b7' : '#fca5a5' }}>{flash.t}</div>}
      <div style={s.tabs}>
        {[['ventas', 'Ventas'], ['cajas', 'Cierres de caja']].map(([k, l]) => (
          <button key={k} style={{ ...s.tab, ...(tab === k ? s.tabOn : {}) }} onClick={() => setTab(k)}>{l}</button>
        ))}
      </div>

      {tab === 'ventas' && <>
        <div style={s.kpis}>
          <Kpi label="Total" value={fmt(t.total)} color="#f1f5f9" />
          <Kpi label="Efectivo" value={fmt(t.efectivo)} color="#6ee7b7" />
          <Kpi label="Tarjeta" value={fmt(t.tarjeta)} color="#93c5fd" />
          <Kpi label="QR / Bre-B" value={fmt(t.qr)} color="#c4b5fd" />
          <Kpi label="Ventas" value={rep?.count ?? 0} color="#fbbf24" />
        </div>
        <div style={s.card}>
          <table style={s.table}>
            <thead><tr>{['Hora', 'Documento', 'Tipo', 'Pago', 'Total', ''].map((h, i) => <th key={i} style={s.th}>{h}</th>)}</tr></thead>
            <tbody>
              {(rep?.ventas || []).map(v => {
                const b = TIPO_BADGE[v.tipo_doc] || TIPO_BADGE.fe;
                const neg = Number(v.total) < 0;
                const puedeDevolver = v.tipo_doc !== 'devolucion' && v.estado !== 'devuelta';
                return (
                  <tr key={v.id}>
                    <td style={s.td}>{fdt(v.created_at)}</td>
                    <td style={{ ...s.td, color: '#93c5fd' }}>{v.numero || '—'}</td>
                    <td style={s.td}>
                      <span style={{ ...s.badge, background: b.bg, color: b.c }}>{b.l}</span>
                      {v.estado === 'parcial' && <span style={{ ...s.badge, background: '#422006', color: '#fbbf24', marginLeft: 6 }}>dev. parcial</span>}
                    </td>
                    <td style={s.td}>{v.forma || v.medio_pago}</td>
                    <td style={{ ...s.td, textAlign: 'right', color: neg ? '#fca5a5' : '#e2e8f0' }}>{fmt(v.total)}</td>
                    <td style={{ ...s.td, textAlign: 'right' }}>
                      {puedeDevolver && <button style={s.devBtn} onClick={() => setDevolver(v)}>Devolver</button>}
                    </td>
                  </tr>
                );
              })}
              {(!rep || rep.ventas.length === 0) && <tr><td colSpan={6} style={s.empty}>Sin ventas en el período.</td></tr>}
            </tbody>
          </table>
        </div>
      </>}

      {tab === 'cajas' && (
        <div style={s.card}>
          <table style={s.table}>
            <thead><tr>{['Apertura', 'Cierre', 'Cajero', 'Base', 'Ventas', 'Efectivo esp.', 'Contado', 'Diferencia', 'Estado'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
            <tbody>
              {cajas.map(c => (
                <tr key={c.id}>
                  <td style={s.td}>{fdt(c.abierta_en)}</td>
                  <td style={s.td}>{fdt(c.cerrada_en)}</td>
                  <td style={s.td}>{c.usuario || '—'}</td>
                  <td style={s.td}>{fmt(c.base_inicial)}</td>
                  <td style={s.td}>{c.ventas} · {fmt(c.ventas_total)}</td>
                  <td style={s.td}>{fmt(c.efectivo_esperado)}</td>
                  <td style={s.td}>{c.efectivo_contado != null ? fmt(c.efectivo_contado) : '—'}</td>
                  <td style={{ ...s.td, color: c.diferencia == null ? '#64748b' : c.diferencia === 0 ? '#6ee7b7' : '#fca5a5' }}>{c.diferencia != null ? fmt(c.diferencia) : '—'}</td>
                  <td style={s.td}><span style={{ ...s.badge, background: c.estado === 'abierta' ? '#78350f' : '#1e293b', color: c.estado === 'abierta' ? '#fcd34d' : '#94a3b8' }}>{c.estado}</span></td>
                </tr>
              ))}
              {cajas.length === 0 && <tr><td colSpan={9} style={s.empty}>Sin sesiones de caja.</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {devolver && <DevolucionModal venta={devolver} onClose={() => setDevolver(null)}
        onHecho={() => { setDevolver(null); cargar(); }} aviso={aviso} />}
    </div>
  );
}

// Modal de devolución: carga el detalle de la venta y permite devolver todo o parte.
function DevolucionModal({ venta, onClose, onHecho, aviso }) {
  const [det, setDet] = useState(null);
  const [cant, setCant] = useState({}); // idx -> cantidad a devolver
  const [motivo, setMotivo] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    posVentaDetalle(venta.id).then(r => {
      setDet(r.data);
      const init = {}; (r.data.items || []).forEach((it, i) => { init[i] = it.max_devolver; });
      setCant(init);
    }).catch(() => aviso(false, 'No se pudo cargar la venta'));
  }, [venta.id]); // eslint-disable-line

  const items = det?.items || [];
  const lineTot = (it, c) => (Number(c) || 0) * Number(it.precio_unitario) * (1 - (Number(it.descuento_pct) || 0) / 100) * (1 + (Number(it.iva_pct) || 0) / 100);
  const totalDev = items.reduce((s, it, i) => s + lineTot(it, cant[i]), 0);

  const confirmar = async () => {
    const devolver = items.map((it, i) => ({ ...it, cantidad: Number(cant[i]) || 0 })).filter(x => x.cantidad > 0);
    if (!devolver.length) { aviso(false, 'Indica al menos una cantidad a devolver'); return; }
    setBusy(true);
    try {
      const { data } = await posDevolucion(venta.id, { items: devolver, motivo });
      aviso(true, `✅ Devolución ${data.es_nc ? '· Nota crédito ' : ''}${data.numero} · ${fmt(data.total)}`);
      onHecho();
    } catch (e) { aviso(false, '❌ ' + (e.response?.data?.error || 'No se pudo registrar la devolución')); setBusy(false); }
  };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={{ ...s.modalCard }} onClick={e => e.stopPropagation()}>
        <h3 style={{ ...s.h1, fontSize: 18 }}>Devolver — {venta.numero}</h3>
        <p style={s.sub}>{det?.es_fe ? 'Genera una nota crédito electrónica y reingresa el stock.' : 'Reingresa el stock y registra la devolución (sin DIAN).'}</p>
        <div style={{ maxHeight: '45vh', overflowY: 'auto', margin: '12px 0' }}>
          {!det && <div style={{ color: '#64748b', padding: 12 }}>Cargando…</div>}
          {items.map((it, i) => (
            <div key={i} style={s.devRow}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ color: '#e2e8f0', fontSize: 13 }}>{it.descripcion}</div>
                <div style={{ color: '#64748b', fontSize: 11 }}>Vendidas {it.cantidad}{it.ya_devuelta ? ` · ya devuelto ${it.ya_devuelta}` : ''} · {fmt(it.precio_unitario)}</div>
              </div>
              <input type="number" min="0" max={it.max_devolver} style={{ ...s.in, width: 64, textAlign: 'center' }}
                value={cant[i] ?? 0} onChange={e => { const v = Math.max(0, Math.min(it.max_devolver, Number(e.target.value) || 0)); setCant(c => ({ ...c, [i]: v })); }} />
              <div style={{ width: 90, textAlign: 'right', color: '#cbd5e1', fontSize: 13 }}>{fmt(lineTot(it, cant[i]))}</div>
            </div>
          ))}
        </div>
        <input style={{ ...s.in, width: '100%', boxSizing: 'border-box', marginBottom: 12 }} placeholder="Motivo (opcional)" value={motivo} onChange={e => setMotivo(e.target.value)} />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <span style={{ color: '#94a3b8' }}>A devolver</span>
          <span style={{ color: '#fca5a5', fontSize: 20, fontWeight: 800 }}>{fmt(totalDev)}</span>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button style={s.btnGhost} onClick={onClose}>Cancelar</button>
          <button style={{ ...s.btnDanger, flex: 1, opacity: totalDev > 0 ? 1 : .5 }} disabled={busy || totalDev <= 0} onClick={confirmar}>{busy ? 'Procesando…' : `Devolver ${fmt(totalDev)}`}</button>
        </div>
      </div>
    </div>
  );
}

const Kpi = ({ label, value, color }) => (
  <div style={s.kpi}><div style={{ fontSize: 22, fontWeight: 700, color }}>{value}</div><div style={{ fontSize: 12, color: '#64748b' }}>{label}</div></div>
);

const s = {
  pageHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap', marginBottom: 14 },
  h1: { color: '#f1f5f9', fontSize: 24, fontWeight: 700, margin: '0 0 4px' },
  sub: { color: '#64748b', fontSize: 14, margin: 0 },
  tabs: { display: 'flex', gap: 8, marginBottom: 14 },
  tab: { background: '#0f172a', border: '1px solid #334155', color: '#94a3b8', borderRadius: 8, padding: '7px 16px', fontSize: 13, cursor: 'pointer' },
  tabOn: { background: '#1e3a5f', border: '1px solid #3b82f6', color: '#7dd3fc' },
  filtros: { display: 'flex', gap: 8, alignItems: 'center', marginBottom: 14, flexWrap: 'wrap' },
  lbl: { color: '#94a3b8', fontSize: 12 },
  in: { background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '8px 10px', color: '#f1f5f9', fontSize: 13 },
  btn: { background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer' },
  kpis: { display: 'flex', gap: 12, marginBottom: 14, flexWrap: 'wrap' },
  kpi: { flex: '1 1 150px', background: '#1e293b', border: '1px solid #334155', borderRadius: 10, padding: '14px 18px', textAlign: 'center' },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, overflow: 'auto' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: { textAlign: 'left', padding: '10px 12px', color: '#64748b', fontSize: 11, textTransform: 'uppercase', letterSpacing: .5, borderBottom: '1px solid #334155', background: '#0f172a', whiteSpace: 'nowrap' },
  td: { padding: '9px 12px', color: '#94a3b8', borderBottom: '1px solid #16202e', whiteSpace: 'nowrap' },
  empty: { padding: 28, textAlign: 'center', color: '#64748b' },
  badge: { padding: '2px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600 },
  flash: { padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 12 },
  devBtn: { background: 'transparent', color: '#fca5a5', border: '1px solid #7f1d1d', borderRadius: 7, padding: '5px 12px', fontSize: 12, cursor: 'pointer' },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16 },
  modalCard: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, padding: 20, width: 480, maxWidth: '100%' },
  devRow: { display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderBottom: '1px solid #16202e' },
  btnGhost: { background: 'transparent', color: '#94a3b8', border: '1px solid #334155', borderRadius: 8, padding: '10px 16px', fontSize: 13, cursor: 'pointer' },
  btnDanger: { background: '#b91c1c', color: '#fff', border: 'none', borderRadius: 10, padding: '11px 18px', fontSize: 14, fontWeight: 700, cursor: 'pointer' },
};
